module.exports = __webpack_public_path__ + "c08704768b785e854086f7e8484e0fe1.svg";